import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  alias: () => i18n.t(i18nKeys.previous__alias__type__alias),
  maidenName: () => i18n.t(i18nKeys.previous__alias__type__maidenName),
  otherName: () => i18n.t(i18nKeys.previous__alias__type__other),
  required: () => i18n.t(i18nKeys.previous__alias__required),
  type: () => i18n.t(i18nKeys.previous__alias__type),
  name: () => i18n.t(i18nKeys.previous__alias__name),
  firstName: () => i18n.t(i18nKeys.previous__alias__firstName),
  middleName: () => i18n.t(i18nKeys.previous__alias__middleName),
  lastName: () => i18n.t(i18nKeys.previous__alias__lastName),
  isSingleName: () => i18n.t(i18nKeys.previous__alias__isSingleName),
  remove: () => i18n.t(i18nKeys.previous__alias__remove),
}
